import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_freight_billing_order_scheduler_listService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { date_filter?: string, order_id?: number, operationcode_id: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ModifiedSysDateTime?: string, OrderClassId?: number, OrderStatusId?: number, Tasks?: { Id?: number, StatusId?: number }[], OrderClass?: { Id?: number, OrderTypeId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationcode_id)) {
      missingRequiredInParams.push('\'operationcode_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_freight_billing_order_scheduler_list/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { date_filter?: string, order_id?: number, operationcode_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ModifiedSysDateTime?: string, OrderClassId?: number, OrderStatusId?: number, Tasks?: { Id?: number, StatusId?: number }[], OrderClass?: { Id?: number, OrderTypeId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationcode_id)) {
      missingRequiredInParams.push('\'operationcode_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_freight_billing_order_scheduler_list/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { date_filter?: string, order_id?: number, operationcode_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ModifiedSysDateTime?: string, OrderClassId?: number, OrderStatusId?: number, Tasks?: { Id?: number, StatusId?: number }[], OrderClass?: { Id?: number, OrderTypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationcode_id)) {
      missingRequiredInParams.push('\'operationcode_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_freight_billing_order_scheduler_list/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      date_filter?: string, order_id?: number, operationcode_id: number    }) {
        if(isNil(inParams.operationcode_id)) {
          return true; 
        }
      return false;
    }
}
